import React from 'react'

import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text'
import {
  Sheet,
  SheetOverlay,
  SheetContent,
  SheetTitle,
  SheetCloseButton,
  SheetBody,
} from '@wartek-id/sheet'
import { Button } from '@wartek-id/button'

import { nl2br, removeTagsStyleAttribute } from 'utils/text'

type TRevisionSheetProps = {
  isAppealEligible: boolean
  isOpen: boolean
  onClickAppeal: () => void
  onClickFix: () => void
  revisionMessage: string
  setIsOpen: Function
}
const RevisionSheet = ({
  isAppealEligible,
  isOpen,
  onClickAppeal,
  onClickFix,
  revisionMessage,
  setIsOpen,
}: TRevisionSheetProps) => {
  const [isAppealClicked, setAppealClicked] = React.useState(false)

  React.useEffect(() => {
    if (isAppealClicked) setAppealClicked(false)
  }, [isAppealClicked])

  return (
    <Sheet
      isOpen={isOpen}
      onClose={setIsOpen}
      animationDuration={{ enter: 0, exit: isAppealClicked ? 0 : 300 }}
    >
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <SheetTitle bordered>
          <Text variant="heading-sm">Perbaikan</Text>
        </SheetTitle>
        <SheetCloseButton />
        <SheetBody>
          <div className="border border-subdued rounded m-4">
            <Text
              className="px-4 py-5 pb-3"
              dangerouslySetInnerHTML={{
                __html: removeTagsStyleAttribute(nl2br(revisionMessage)),
              }}
            />
            <div className="p-3">
              <Button
                data-testid="fix-button"
                color="black"
                fullWidth
                size="lg"
                onClick={() => onClickFix()}
              >
                Perbaiki Aksi Nyata
              </Button>
            </div>
          </div>
          {isAppealEligible && (
            <div className="px-4 text-center">
              <Text>
                Merasa saran perbaikan ini keliru dan ingin Aksi Nyata Anda
                divalidasi ulang?
              </Text>
              <div className="pt-2 pb-6">
                <Link
                  data-testid="appeal-button"
                  onClick={() => {
                    setAppealClicked(true)
                    onClickAppeal()
                  }}
                  underline
                  variant="primary"
                >
                  Ajukan banding
                </Link>
              </div>
            </div>
          )}
        </SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default RevisionSheet
